import React from "react";
import Advertisements from "../../images/Advertisements.png";
import image1 from "../../images/AdvertSideImage (1).png";
// import image2 from "../../images/AdvertSideImage (2).png";
import image3 from "../../images/newsus.webp";
// import image4 from "../../images/Rectangle 333.png";

const sidebarData = [
  {
    id: 1,
    tag: "Solar energy",
    tagBg: "bg-[#664101]",
    date: "Mar 03, 2026",
    title: "Ensuring safety and optimised production of lithium batteries",
    description: "Lithium batteries are crucial for decarbonisation. We must boost production and reduce costs.",
    image: image1,
  },
  // {
  //   id: 2,
  //   tag: "Clean Energy",
  //   tagBg: "bg-[#00AED9]",
  //   date: "Feb 14, 2026",
  //   title: "Next-level blue hydrogen production with advanced measurement",
  //   description: "Discover measurement solutions to enhance plant safety, boost efficiency, and lower energy use.",
  //   image: image2,
  // },
  {
    id: 3,
    tag: "Sustainability",
    tagBg: "bg-[#40B869]",
    date: "Jan 21, 2026",
    title: "Is your workplace updated on sustainable hygiene?",
    description: "Discover the benefits and approach to sustainable hygiene solutions in the workplace.",
    image: image3,
  },
];

export default function AdvertisementLayout() {
  return (
    <div className="flex flex-col mt-12 sm:mt-16 xl:mt-20 items-start gap-6 sm:gap-8 xl:gap-[40px] w-full max-w-[1200px] h-auto mx-auto px-4 sm:px-8 xl:px-0">
      {/* Header section */}
      <div className="flex flex-col items-start gap-[32px] w-full">
        <h2 className="w-full text-[26px] sm:text-[32px] xl:text-[36px] font-medium leading-[1.2] xl:leading-[43px] text-[#3B3B3B]">
          Advertisements
        </h2>
      </div>

      {/* Main Content Area */}
      <div className="flex flex-row flex-wrap items-start content-start gap-[24px] w-full">
        {/* Left Side: Hero Banner Card */}
        <HeroCard />

        {/* Right Side: Small Vertical Cards Column */}
        <div className="flex flex-col justify-center items-start w-full xl:w-[410px] h-auto xl:h-[681px]">
          {sidebarData.map((card) => (
            <SidebarCard key={card.id} {...card} />
          ))}
        </div>

        {/* Bottom Section: Full Width Horizontal Banner */}
        {/* <BottomCard /> */}
      </div>
    </div>
  );
}

/* ==========================================
   SUB-COMPONENTS FOR CLEAN ARCHITECTURE
   ========================================== */

function HeroCard() {
  return (
    <div className="relative w-full xl:w-[766px] min-h-[500px] xl:min-h-0 xl:h-[682px] rounded-[16px] overflow-hidden group">
      {/* Background Image Layer */}
      <img
        src={Advertisements}
        alt="Hero Advertisement"
        className="absolute inset-0 w-full h-full object-cover bg-center rounded-t-xl xl:inset-auto xl:mt-10 xl:w-auto xl:h-auto"
      />

      {/* Backdrop Tint Blur Overlay */}
      <div className="absolute inset-0 bg-black/28 " />

      {/* Content wrapper — flow on mobile, absolute context on desktop */}
      <div className="relative flex flex-col justify-between min-h-[500px] xl:min-h-0 xl:absolute xl:inset-0 xl:block p-6 sm:p-8 xl:p-0">
        {/* Top Header Floating Tags */}
        <div className="flex flex-row items-center gap-2 flex-wrap xl:absolute xl:left-[5px] xl:top-[36px] xl:gap-[8px] xl:h-[25px] xl:p-10">
          <div className="flex flex-row justify-center items-center px-2 py-0.5 xl:px-[8px] xl:py-[2px] bg-[#7BC216] rounded-[4px]">
            <span className="text-[14px] sm:text-[16px] xl:text-[18px] font-normal text-white ">Clean Energy</span>
          </div>
          <div className="w-[10px] h-[10px] bg-[#D9D9D9] rounded-full" />
          <span className="text-[14px] sm:text-[16px] xl:text-[18px] font-normal text-white ">Mar. 13, 2026</span>
        </div>

        {/* Inner Main Content Block */}
        <div className="flex flex-col items-start gap-[24px] w-full xl:absolute xl:left-[36px] xl:top-[334px] xl:w-[calc(100%-72px)] xl:max-w-[657px]">
          <div className="flex flex-col items-start gap-[12px] w-full">
            <div className="flex flex-col items-start gap-[16px] w-full">
              <h3 className="w-full text-[22px] sm:text-[28px] xl:text-[36px] font-semibold text-white leading-[120%] font-['Inter']">
                Revolutionizing Grid Stability with Tier-1 Solar Storage
              </h3>
              <p className="w-full text-[14px] sm:text-[16px] xl:text-[18px] font-normal text-[#D0D5DD] leading-[120%] tracking-[0.01em] font-['Inter']">
                As our featured Sustainability Partner, EcoWatt provides CloseCarbon-verified energy infrastructure that reduces operational carbon footprints by up to 40% for heavy.
              </p>
            </div>
          </div>

          {/* Action Elements Row */}
          <div className="flex flex-row items-center justify-between w-full flex-wrap gap-4">
            <div className="flex flex-row items-center gap-[12px] flex-wrap">
              {/* Meta Pill 1 */}
              <div className="flex justify-center items-center px-[16px] py-[8px] h-[33px] bg-black/5 border border-[#898989] backdrop-blur-[12.5px] rounded-[16px]">
                <span className="text-[12px] sm:text-[14px] font-normal text-[#B1B1B1] ">99.9% Up time</span>
              </div>
              {/* Meta Pill 2 */}
              <div className="flex justify-center items-center px-[16px] py-[8px] h-[33px] bg-black/25 border border-[#898989] backdrop-blur-[20px] rounded-[16px]">
                <span className="text-[12px] sm:text-[14px] font-normal text-[#B1B1B1] ">Nigeria-Wide Support</span>
              </div>
            </div>

            {/* Core Button Container */}
          </div>
        </div>
      </div>
    </div>
  );
}

function SidebarCard({ tag, tagBg, date, title, description, image }) {
  return (
    <div className="box-border mt-10 items-center p-0 pl-[12px] pr-[12px] gap-[3px] w-full xl:w-[410px] h-auto xl:h-[333px] bg-white border-[0.32px] border-[#E4E7EC] shadow-[0px_7px_29px_rgba(100,100,111,0.2)] rounded-[12px]">
      {/* Left-Side Thumbnail */}
      <img
        className="w-full h-[187px] object-cover border-[0.32px] border-[#FAFAFA] rounded-t-[20px] rounded-b-[15px] p-3 pt-5"
        src={image}
        alt="Advertisement Thumbnail"
      />

      {/* Right-Side Meta/Details Stack */}
      <div className="flex flex-col items-start gap-[12px] w-full h-[130px]">
        <div className="flex flex-col items-start gap-[12px] w-full">
          {/* Top Tag Bar */}
          <div className="flex flex-row items-center gap-[4px] w-full mt-5">
            <div className={`flex justify-center items-center h-[16px] ${tagBg} rounded-[1.91px]`}>
              <span className="text-[8.6px] font-normal text-white truncate whitespace-nowrap p-3">{tag}</span>
            </div>
            <div className="w-[4.8px] h-[4.8px] bg-[#D9D9D9] rounded-full shrink-0" />
            <span className="text-[10px] font-normal text-[#B1B1B1] whitespace-nowrap">{date}</span>
          </div>

          {/* Card Headings */}
          <div className="flex flex-col items-start gap-[4px] w-full">
            <h4 className="w-full text-[14px] font-bold text-[#3B3B3B] leading-[17px] line-clamp-3">
              {title}
            </h4>
            <p className="w-full text-[12px] font-normal text-[#898989] leading-[12px] pt-5 line-clamp-3">
              {description}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}